export const useRemoveDomain = <T extends string | string[]>(urls: T): T => {
  const process = (url: string) => {
    try {
      const { pathname, search, hash } = new URL(url);
      return pathname + search + hash;
    } catch {
      // Если это не полная ссылка, возвращаем как есть
      return url;
    }
  };

  return Array.isArray(urls) ? (urls.map(process) as T) : (process(urls) as T);
};
